const STATE = 'state';

export const saveToLocalStorage = (state) => {
	try {
		// console.log('store.getState()', state);
		const serializedState = JSON.stringify(state);
		// console.log('saveToLocalStorage', serializedState);
		localStorage.setItem(STATE, serializedState);
	} catch (e) {
		console.log(e);
	}
};

export const getPreloadedState = () => {
	try {
		const serializedState = localStorage.getItem(STATE);
		// console.log('getPreloadedState', serializedState);
		if (serializedState === null) return undefined;
		const parsedJSON = JSON.parse(serializedState);
		return { ...parsedJSON };
	} catch (e) {
		console.log(e);
		return undefined;
	}
};
